import React, { useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Language = 'cs' | 'en';
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string, params?: Record<string, string>) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Language>('cs');
  const t = (key: string, params?: Record<string, string>) => {
    const keys = key.split('.');
    let value: any = translations[lang];
    for (const k of keys) {
      if (value === undefined) break;
      value = value[k];
    }
    if (value === undefined) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
    if (typeof value === 'string' && params) {
      return Object.entries(params).reduce((str, [k, v]) => str.replace(new RegExp(`{${k}}`, 'g'), v), value);
    }
    return value;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-117">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}